import { render, staticRenderFns } from "./trend.vue?vue&type=template&id=26853f98"
import script from "./trend.vue?vue&type=script&lang=js"
export * from "./trend.vue?vue&type=script&lang=js"
import style0 from "./trend.vue?vue&type=style&index=0&id=26853f98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports